// extracted by mini-css-extract-plugin
module.exports = {"icon":"NewAccountIcon__icon___2w8l5","filled":"NewAccountIcon__filled___1zIxy","stroked":"NewAccountIcon__stroked___10iEB"};